import { useAbTestFeatureVariant } from '@sprd/sprd-abtest-next/client';
import { usePlatform } from '@/atoms/processEnvAtom';

/**
 * Client-side gate for express checkout in the mini basket: shown for the EU
 * platform, or elsewhere unless the "express-checkout" A/B test explicitly
 * returns `hidden`. `visible` is the fallback, so the test can only opt
 * visitors out, not in.
 */
export const useIsExpressCheckoutEnabled = () => {
  const platform = usePlatform();
  const isVariantEnabled = useAbTestFeatureVariant("express-checkout", "visible") === "visible";
  return platform === "EU" || isVariantEnabled;
};